import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";
import router from "@/router";
const state = {
    shopRequests: [],
    shopRequestsPages: [],
    requestsPageSize: 8,
    shopRequestForm: {
        id: 0,
        name: "",
        description: "",
        address: "",
        categoriesIds: [],
        phoneNumber: "",
        mobileNumber: "",
        email: "",
        latitude: "",
        longitude: "",
        otp: Math.floor(100000 + Math.random() * 900000).toString(),
        mainImage: [],
        shopContactInfos: [],
        shopType: 0,
        areaId: null,
        scheduleTemplateId: null,
        isCustom: false,
        subscribeStartDate: new Date().toISOString().substr(0, 10),
        subscribeEndDate: new Date(
            new Date().setMonth(new Date().getMonth() + 1)
        )
            .toISOString()
            .substr(0, 10),
        isHidden: false,
        customSchedules: []
    }
};
const getters = {
    shopRequests(state) {
        return state.shopRequests;
    },
    shopRequestsPages(state) {
        return state.shopRequestsPages;
    },
    shopRequestForm(state) {
        return state.shopRequestForm;
    },
    requestsPageSize(state) {
        return state.requestsPageSize;
    }
};
const mutations = {
    GET_SHOP_REQUESTS(state, payload) {
        state.shopRequests = payload;
        state.shopRequestsPages = state.shopRequests.slice(
            0,
            state.requestsPageSize
        );
        store.dispatch("setLoading", false);
    },
    CHANGE_SHOP_REQUESTS_PAGE(state, payload) {
        state.shopRequestsPages = state.shopRequests.slice(
            (payload - 1) * state.requestsPageSize,
            (payload - 1) * state.requestsPageSize + state.requestsPageSize
        );
    },
    GET_SHOP_REQUEST_DETAILS(state, payload) {
        payload.shopDto.subscribeStartDate = new Date(
            payload.shopDto.subscribeStartDate
        )
            .toISOString()
            .substr(0, 10);
        payload.shopDto.subscribeEndDate = new Date(
            payload.shopDto.subscribeEndDate
        )
            .toISOString()
            .substr(0, 10);
        payload.shopDto.mainImage = [payload.shopDto.mainImage];
        payload.shopDto.customSchedules = [];
        payload.shopDto.categoriesIds = payload.shopDto.categoriesIds;
        payload.shopDto.shopContactInfos = [];
        state.shopRequestForm = payload.shopDto;
        store.state.shop.categoriesList = payload.categoriesList;
        store.state.shop.shopTypes = payload.shopTypes;
        store.state.shop.shopContactInfoType = payload.shopContactInfoTypes;
        store.dispatch("setLoading", false);
    },
    NEW_SHOP_REQUEST_SOCIAL(state, payload) {
        state.shopRequestForm.shopContactInfos.unshift({
            id: 0,
            name: store.state.shop.shopContactInfoType.filter(infoType => {
                return infoType.id == payload;
            })[0].name,
            link:
                payload == 9
                    ? ""
                    : payload == 8
                    ? "963"
                    : payload == 7
                    ? "963"
                    : payload == 6
                    ? "profilename"
                    : payload == 5
                    ? "profilename"
                    : payload == 3
                    ? "profilename"
                    : payload == 2
                    ? "profilename"
                    : payload == 1
                    ? "profilename"
                    : "",
            infoType: payload
        });
        console.log(payload);
    },
    REMOVE_SHOP_REQUEST_SOCIAL(state, index) {
        state.shopRequestForm.shopContactInfos.splice(index, 1);
    },
    APPROVE_SHOP_REQUEST(state, payload) {
        router.push("/shop-request");
    },
    REMOVE_SHOP_REQUEST(state, payload) {
        const index = state.shopRequests.findIndex(
            item => item.id == payload.id
        );
        state.shopRequests.splice(index, 1);
        store.dispatch("setLoading", false);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف طلب المشترك ${payload.name} بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 2000
        });
    }
};
const actions = {
    async fetchShopRequests(context) {
        const { data } = await api
            .query(`/api/Shop/GetShopRequests`)
            .then(data => data);
        context.commit("GET_SHOP_REQUESTS", data);
    },
    async changeShopRequestPage(context, payload) {
        context.commit("CHANGE_SHOP_REQUESTS_PAGE", payload);
    },
    async fetchShopRequestDetails(context, payload) {
        const { data } = await api
            .query(`/api/Shop/GetShopRequestDetails/${payload}`)
            .then(data => data);
        context.commit("GET_SHOP_REQUEST_DETAILS", data);
    },
    unShiftSocial(context, payload) {
        context.commit("NEW_SHOP_REQUEST_SOCIAL", payload);
    },
    removeShopRequestInfoSocial(context, index) {
        context.commit("REMOVE_SHOP_REQUEST_SOCIAL", index);
    },
    async approveShopRequest(context, payload) {
        store.dispatch("setLoading", true);
        payload.shopContactInfos.map(link => {
            link.infoType == 5
                ? (link.link = "https://t.me/" + link.link)
                : link.infoType == 4
                ? (link.link = "https://wa.me/+" + link.link)
                : link.infoType == 3
                ? (link.link = "https://twitter.com/@" + link.link)
                : link.infoType == 2
                ? (link.link = "https://www.instagram.com/" + link.link)
                : link.infoType == 1
                ? (link.link = "https://www.facebook.com/" + link.link)
                : (link.link = "" + link.link);
        });
        if (!!payload.mainImage.length) {
            payload.mainImage = payload.mainImage[0];
        } else {
            payload.mainImage = {};
        }
        await api
            .post(
                "/api/Shop/SetShop",
                {
                    Id: payload.id,
                    Name: payload.name,
                    Description: payload.description,
                    Address: payload.address,
                    PhoneNumber: payload.phoneNumber,
                    MobileNumber: payload.mobileNumber,
                    Email: payload.email,
                    Latitude: payload.latitude,
                    Longitude: payload.longitude,
                    OTP: payload.otp.toString(),
                    ShopType: payload.shopType,
                    SubscribeStartDate: new Date(payload.subscribeStartDate),
                    SubscribeEndDate: new Date(payload.subscribeEndDate),
                    AreaId: payload.areaId,
                    CategoriesIds: payload.categoriesIds,
                    ScheduleTemplateId: payload.scheduleTemplateId,
                    MainImage: payload.mainImage,
                    ShopContactInfos:
                        payload.shopContactInfos == null
                            ? []
                            : payload.shopContactInfos,
                    IsCustom: payload.isCustom,
                    CustomSchedules:
                        payload.customSchedules == null
                            ? []
                            : payload.customSchedules
                },
                {
                    timeout: 300000
                }
            )
            .then(response => {
                if (typeof response.data === "string") {
                    context.commit("ERROR_MESSAGE", response.data);
                } else {
                    context.commit("APPROVE_SHOP_REQUEST", response.data);
                    store.dispatch("setLoading", false);
                }
            });
    },
    async removeShopRequest(context, payload) {
        await api
            .delete(`/api/Shop/RemoveShop?shopId=${payload.id}`)
            .then(data => data);
        context.commit("REMOVE_SHOP_REQUEST", payload);
    }
};

const shopRequest = { state, getters, mutations, actions };

export default shopRequest;
